<template>
  <div>
    <Header> </Header>
    <IQOSHorizontalScroll>
       <img class="item" :src="imgs[item % imgs.length]" v-for="item in 10">
    </IQOSHorizontalScroll>
    <PageContainer>
      
      <p>asdasdjasd asjdjadj asjd</p>
      <BaseButton class="mt-16" variant="primary" color="v1-grey-10">
        asdasd
      </BaseButton>
      <IQOS class="mt-16" title="Welcome to our IQOS">
        <BaseInput class="mt-16" placeholder="Stuff" />
        <BaseButton class="mt-16" variant="primary" color="green-5">
          Continue
        </BaseButton>
      </IQOS>
      <IQOS class="mt-16" title="Welcome to our required IQOS" required>
        <BaseInput class="mt-16" placeholder="Stuff" />
        <BaseButton class="mt-16" variant="primary" color="green-5">
          Continue
        </BaseButton>
      </IQOS>
      <IQOS class="mt-16" title="Welcome to our additional IQOS" :enabled="iq1">
        <BaseInput class="mt-16" placeholder="Stuff" />
        <BaseButton
          class="mt-16"
          variant="primary"
          color="blue-5"
          @click="iq1 = !iq1"
        >
          Toggle
        </BaseButton>
      </IQOS>

      <div class="iqos-grid mb-32">
        <div class="iqos-column">
          <IQOS
            class="mt-16"
            title="Welcome to our additional IQOS"
            :enabled="iq1"
          >
            <BaseInput class="mt-16" placeholder="Stuff" />
            <BaseButton
              class="mt-16"
              variant="primary"
              color="blue-5"
              @click="iq1 = !iq1"
            >
              Toggle
            </BaseButton>
          </IQOS>
        </div>
        <div class="iqos-column">
          <IQOS
            class="mt-16"
            title="Welcome to our additional IQOS"
            :enabled="iq1"
          >
            <BaseInput class="mt-16" placeholder="Stuff" />
            <BaseButton
              class="mt-16"
              variant="primary"
              color="blue-5"
              @click="iq1 = !iq1"
            >
              Toggle
            </BaseButton>
          </IQOS>
        </div>
      </div>

      <h1 class="qrw-heading-xs" v-for="n in 10">
        Lorem ipsum color dit sametLorem ipsum color dit sametLorem ipsum color
        dit sametLorem ipsum color dit sametLorem ipsum color dit sametLorem
        ipsum color dit sametLorem ipsum color dit sametLorem ipsum color dit
        sametLorem ipsum color dit sametLorem ipsum color dit sametLorem ipsum
        color dit sametLorem ipsum color dit sametLorem ipsum color dit
        sametLorem ipsum color dit sametLorem ipsum color dit sametLorem ipsum
        color dit sametLorem ipsum color dit sametLorem ipsum color dit
        sametLorem ipsum color dit sametLorem ipsum color dit sametLorem ipsum
        color dit sametLorem ipsum color dit sametLorem ipsum color dit
        sametLorem ipsum color dit sametLorem ipsum color dit sametLorem ipsum
        color dit samet
      </h1>
    </PageContainer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      iq1: false,
      imgs: [
        'https://picsum.photos/1280/720',
        'https://picsum.photos/365/800'
      ]
    };
  },
};
</script>

<style>
.items-container {
  display: flex;
  width: 100%;
  height: 200px;
}

.item {
  width: 500px;
  height: 100%;
  height: inherit;
  background: red;
}
</style>